import { useTranslation } from 'react-i18next';

import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@app/shared/ui/atoms/Common';
import { defaultTelegramVibrate } from '@app/shared/utils/common';

interface CountSelectProps {
  value?: string;
  onChange: (value: string) => void;
  length: number;
  start?: number;
  step?: number;
  label?: string;
  itemKey: string;
  getValue?: (i: number) => string | number;
  disabled?: boolean;
}

export function CountSelect({
  value,
  onChange,
  length,
  start = 1,
  step = 1,
  label,
  itemKey,
  getValue,
  disabled,
}: CountSelectProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      {label && <Label className="font-semibold">{label}</Label>}
      <Select
        value={value}
        onValueChange={onChange}
        onOpenChange={defaultTelegramVibrate}
        disabled={disabled}
      >
        <SelectTrigger className="h-8 rounded-full text-sm !text-secondary-foreground min-w-[180px]">
          <SelectValue placeholder={t('profit_calc.people_select_placeholder')} />
        </SelectTrigger>
        <SelectContent position="popper" avoidCollisions={false} className="z-102">
          {Array.from({ length }, (_, i) => {
            const computedValue = getValue ? getValue(i) : start + i * step;
            return (
              <SelectItem key={computedValue} value={String(computedValue)} className="text-nowrap">
                {t(itemKey, { count: Number(computedValue) })}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
}
